(function () {
  // The header's CTA is a plain link everywhere except the product page, where
  // Liquid renders it as a button instead. So this script only ever sees the
  // add-to-cart flavour — there is no page check to make here.
  var SELECTOR = '[data-sych-header-atc]';

  function variantId(button) {
    /* Prefer whatever the product page currently has selected so a variant
       switch after page load is respected, and fall back to the id Liquid
       rendered. The custom product section exposes it on its root; a Dawn
       product form keeps it on the hidden `id` input. */
    var pm = document.querySelector('[data-sych-pm][data-main-variant]');
    if (pm && pm.dataset.mainVariant) return pm.dataset.mainVariant;

    var input = document.querySelector('product-form form [name="id"]:not([disabled])');
    if (input && input.value) return input.value;

    return button.dataset.variantId || '';
  }

  function setLoading(button, isLoading) {
    // `loading` is the theme's own button state (see base.css); the spinner
    // markup comes from the shared loading-spinner snippet.
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function markSoldOut(button) {
    var label = button.querySelector('.product-btn__label');
    if (label && button.dataset.soldOutText) label.textContent = button.dataset.soldOutText;
    button.disabled = true;
  }

  function onClick(event) {
    var button = event.currentTarget;
    if (button.disabled || button.classList.contains('loading')) return;

    var id = parseInt(variantId(button), 10);
    if (!id) return;

    setLoading(button, true);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          // The only failure worth showing in the header is the variant having
          // gone out of stock while the page sat open; anything else (throttling,
          // cart limits) is transient and the button stays clickable.
          if (result.data && result.data.status === 422) markSoldOut(button);
          console.warn('[sych-header-atc]', (result.data && (result.data.description || result.data.message)) || 'add to cart failed');
          return;
        }

        /* Same convention sych-product-main.js follows: sych-cart-drawer-sync.js
           listens for this and re-renders + opens the drawer. Without a drawer
           on the page there is nothing to open, so fall through to the cart. */
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (!document.querySelector('cart-drawer')) window.location = window.routes.cart_url;
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  function bind(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (button) {
      if (button.dataset.sychHeaderAtcBound) return;
      button.dataset.sychHeaderAtcBound = 'true';
      button.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  // The header re-renders on its own when its settings change in the editor.
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
